angular.module('rmApp')
    .service('disableMenu', require('./disableMenu'))
    .service('timeFormatter', require('./timeFormatter'))
    .service('widgets', require('./widgets'))
    .service('wsEvents', require('./wsEvents').default)
    .service('elementReady', require('./elementReady'))
;
